<template>
  <form-group>
    <form-group title="Situação">
      <v-row>
        <v-col cols="9">
          <v-row class="py-2">
            <span>Bloqueado temporariamente: </span>
            <strong>
              <v-chip
                v-if="!isLoading"
                :color="getColor(payload.isTempBlocked)"
                text-color="#FFF"
                class="text-uppercase"
                label
              >
                {{ getLabel(payload.isTempBlocked) }}
              </v-chip>
              <v-progress-circular
                v-else
                color="primary"
              />
            </strong>
          </v-row>
          <v-row class="py-2">
            <span>Bloqueado permanentemente: </span>
            <strong>
              <v-chip
                v-if="!isLoading"
                :color="getColor(payload.isPermBlocked)"
                text-color="#FFF"
                class="text-uppercase"
                label
              >
                {{ getLabel(payload.isPermBlocked) }}
              </v-chip>
              <v-progress-circular
                v-else
                color="primary"
              />
            </strong>
          </v-row>
          <v-row class="py-2">
            <span>Recuperação de senha bloqueada temporariamente: </span>
            <strong>
              <v-chip
                v-if="!isLoading"
                :color="getColor(payload.isTempRecoverPwdBlocked)"
                text-color="#FFF"
                class="text-uppercase"
                label
              >
                {{ getLabel(payload.isTempRecoverPwdBlocked) }}
              </v-chip>
              <v-progress-circular
                v-else
                color="primary"
              />
            </strong>
          </v-row>
          <v-row class="py-2">
            <span>Recuperação de senha bloqueada permanentemente: </span>
            <strong>
              <v-chip
                v-if="!isLoading"
                :color="getColor(payload.isPermRecoverPwdBlocked)"
                text-color="#FFF"
                class="text-uppercase"
                label
              >
                {{ getLabel(payload.isPermRecoverPwdBlocked) }}
              </v-chip>
              <v-progress-circular
                v-else
                color="primary"
              />
            </strong>
          </v-row>
          <v-row
            v-if="payload.reasonBlocked"
            class="py-2"
          >
            <span>Motivo do bloqueio: </span>
            <strong>
              {{ payload.reasonBlocked }}
            </strong>
          </v-row>
        </v-col>
        <v-col cols="3">
          <v-row>
            <v-btn
              color="primary"
              :loading="unlockLoading"
              :disabled="isDisabledUnlock"
              @click="unlock()"
            >
              Desbloquear
            </v-btn>
          </v-row>
          <v-row class="pt-2">
            <v-btn
              color="primary"
              :loading="unlockRecoveryPassLoading"
              :disabled="isDisabledUnlockRecoveryPass"
              @click="unlockRecoveryPass()"
            >
              Desbloquear recuperação senha
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </form-group>
    <form-group title="Dados pessoais do usuário">
      <v-row>
        <v-col cols="6">
          <input-text
            id="input:name"
            v-model="payload.name"
            :rules="[requiredRule]"
            :loading="isLoading"
            label="Nome do usuário"
            required
          />
        </v-col>
        <v-col cols="6">
          <input-mask
            id="input:username"
            v-model="payload.username"
            :loading="isLoading"
            label="Usuário"
            required
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <input-text
            id="input:mothersName"
            v-model="payload.mothersName"
            :loading="isLoading"
            label="Nome da mãe"
            required
          />
        </v-col>
        <v-col cols="6">
          <input-date
            id="input:dateOfBirth"
            v-model="payload.dateOfBirth"
            :loading="isLoading"
            label="Data de nascimento"
            required
          />
        </v-col>
      </v-row>
    </form-group>
    <v-row class="my-2">
      <v-divider />
    </v-row>
    <form-group title="Endereço pessoal do usuário">
      <v-row>
        <v-col cols="6">
          <input-text
            id="input:street"
            v-model="payload.address.street"
            :loading="isLoading"
            label="Rua"
            outlined
          />
        </v-col>
        <v-col cols="6">
          <input-text
            id="input:complement"
            v-model="payload.address.complement"
            :loading="isLoading"
            label="Complemento"
            outlined
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <input-text
            id="input:neighborhood"
            v-model="payload.address.neighborhood"
            :loading="isLoading"
            label="Bairro"
            outlined
          />
        </v-col>
        <v-col cols="6">
          <input-text
            id="input:city"
            v-model="payload.address.city"
            :loading="isLoading"
            label="Cidade"
            outlined
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <input-select
            id="input:state"
            v-model="payload.address.state"
            :loading="isLoading"
            label="Estado"
            :items="stateOptions"
            outlined
          />
        </v-col>
        <v-col cols="3">
          <input-text
            id="input:number"
            v-model="payload.address.number"
            :loading="isLoading"
            label="Número"
            outlined
          />
        </v-col>
        <v-col cols="3">
          <input-text
            id="input:postalCode"
            v-model="payload.address.postalCode"
            v-mask="'#####-###'"
            :loading="isLoading"
            label="CEP"
            outlined
          />
        </v-col>
      </v-row>
    </form-group>
    <v-row class="my-2">
      <v-divider />
    </v-row>
    <form-group title="Contatos">
      <v-row
        v-for="(contact, key) in payload.contacts"
        :key="`contact-${key}`"
      >
        <v-col cols="12">
          <v-row>
            <v-col cols="6">
              <input-select
                id="input:type"
                v-model="contact.type"
                :loading="isLoading"
                :rules="[requiredRule]"
                label="Tipo de contato"
                :items="contactTypeOptions"
                required
              />
            </v-col>
            <v-col cols="6">
              <input-phone
                id="input:cellPhone"
                :value="TelefoneFilter(contact.cellPhone)"
                :loading="isLoading"
                label="Telefone"
                required
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <input-text
                id="input:email"
                v-model="contact.email"
                :loading="isLoading"
                label="E-mail"
                required
              />
            </v-col>
            <v-col cols="6">
              <input-select
                id="input:statusEmail"
                v-model="contact.statusEmail"
                :loading="isLoading"
                label="Status do e-mail"
                :items="statusEmailOptions"
                required
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </form-group>
    <v-row class="my-2">
      <v-divider />
    </v-row>
    <form-group title="Sistemas">
      <user-expandable-list
        :row="payload"
        :loading="isLoading"
      />
    </form-group>
  </form-group>
</template>

<script>
import RulesMixin from 'Arch/mixins/RulesMixin';
import FormGroup from 'Arch/components/crud/components/FormGroup.vue';
import UserExpandableList from 'App/users/components/tables/UserExpandableList.vue';
import UF from 'Arch/enums/UF';
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';
import TelefoneFilter from '@/app/arch/filters/TelefoneFilter';
import UsersRequest from '../../UsersRequest';

export default {
  name: 'UserProfileForm',
  components: { FormGroup, UserExpandableList },
  mixins: [RulesMixin, ServiceMixin],
  props: {
    value: {
      type: Object,
      default() {
        return {
          dateOfBirth: '',
          mothersName: '',
          address: {
            postalCode: '',
            street: '',
            number: '',
            complement: '',
            neighborhood: '',
            city: '',
            state: '',
          },
          contacts: [
            {
              type: '',
              cellPhone: '',
              email: '',
              statusEmail: '',
            },
          ],
          username: '',
          name: '',
          userSystems: [
            {
              isSessionActive: '',
              userId: '',
              system: '',
              deviceId: '',
              pushNotificationToken: '',
              status: '',
              lastLogin: '',
              username: '',
              completeName: '',
              dateOfBirth: '',
              email: '',
              cellPhone: '',
              id: '',
              createdAt: '',
              updatedAt: '',
              isActive: '',
            },
          ],
          id: '',
          createdAt: '',
          updatedAt: '',
          isActive: '',
          reasonBlocked: '',
          isPermBlocked: '',
          isPermRecoverPwdBlocked: '',
          isTempBlocked: '',
          isTempRecoverPwdBlocked: '',
        };
      },
    },
    loading: {
      type: Boolean,
    },
  },
  data: () => ({
    stateOptions: UF,
    userRequest: UsersRequest,
    unlockLoading: false,
    unlockRecoveryPassLoading: false,
    TelefoneFilter,
    statusOptions: [
      {
        value: '',
        text: 'Validado',
      },
      {
        value: false,
        text: 'Não validado',
      },
    ],
    contactTypeOptions: [
      {
        value: '',
        text: 'Pessoal',
      },
      {
        value: 'Business',
        text: 'Empresa',
      },
    ],
    statusEmailOptions: [
      {
        value: '',
        text: 'Não informado',
      },
      {
        value: 'Pending',
        text: 'Pendente',
      },
      {
        value: 'Confirmed',
        text: 'Confirmado',
      },
    ],
    unlockFaultMessages: {
      successMessage: 'Sucesso ao solicitar desbloqueio!',
      errorMessage: 'Falha ao solicitar desbloqueio',
    },
  }),
  computed: {
    payload() {
      return this.value;
    },
    isLoading() {
      return this.loading;
    },
    getColor() {
      return (bool) => {
        if (bool) {
          return 'primary';
        }
        return 'success';
      };
    },
    getLabel() {
      return (bool) => {
        if (bool) {
          return 'Bloqueado';
        }
        return 'Desbloqueado';
      };
    },
    getIsPermBlocked() {
      return this.payload.isPermBlocked;
    },
    getIsTempBlocked() {
      return this.payload.isTempBlocked;
    },
    isDisabledUnlock() {
      return !(this.getIsPermBlocked || this.getIsTempBlocked);
    },
    isDisabledUnlockRecoveryPass() {
      const { isPermRecoverPwdBlocked, isTempRecoverPwdBlocked } = this.payload;
      return !(isPermRecoverPwdBlocked || isTempRecoverPwdBlocked);
    },
    getUserSystemId() {
      const user = this.payload.userSystems.find(
        (item) => item.system === 'ContaCard',
      );
      if (!user) return 0;
      return user.id;
    },
  },
  methods: {
    unlock() {
      this.handleUnlockLoading();
      this.makeUnlockRequest();
    },
    handleUnlockLoading() {
      this.unlockLoading = !this.unlockLoading;
    },
    makeUnlockRequest() {
      this.callService(
        this.userRequest.unlock(
          this.getUserSystemId,
        ),
        this.unlockFaultMessages,
        () => {
          this.handleUnlockLoading();
          this.reloadProfilePage();
        },
      );
    },
    unlockRecoveryPass() {
      this.unlockRecoveryPassLoading = !this.unlockRecoveryPassLoading;
      this.callService(
        this.userRequest.unlockRecoveryPass(
          this.payload.id,
        ),
        this.unlockFaultMessages,
        () => {
          this.unlockRecoveryPassLoading = !this.unlockRecoveryPassLoading;
          this.reloadProfilePage();
        },
      );
    },
  },
  inject: {
    reloadProfilePage: {
      default() {
        return () => {};
      },
    },
  },
};
</script>
